window.school = {
    data: {
        id: null,
        name: null,
        sessions: [],
        sections: [],
        exams: [],
        electiveSubjects: []
    },

    fetchData: function () {
        const data = this._fetchDataFromLocalStorage();

        if (data) {
            this._onSchoolDataFetched(JSON.parse(data));

            let lastSavedTimestamp = window.localStorage.getItem('school_data_last_saved');
            if (!lastSavedTimestamp || moment.unix(lastSavedTimestamp).isBefore(moment().subtract(1, 'hour'))) {
                console.log("School data saved on local storage is stale. Refreshing from API.")
                this._fetchDataFromApi();
            }
        } else {
            this._fetchDataFromApi(data => this._onSchoolDataFetched(data));
        }
    },

    _fetchDataFromLocalStorage: function () {
        if (window.schoolDataNoCache) {
            return null;
        }

        try {
            const localStorage = window.localStorage;

            if (window.authId) {
                const savedAuthId = localStorage.getItem('auth_id');
                if (savedAuthId !== window.authId.toString()) {
                    localStorage.removeItem('school_data');
                    localStorage.removeItem('school_data_inventory');
                }
            }

            return localStorage.getItem(this._schoolDataKey());
        } catch (e) {
            console.error("Error accessing local storage.", e);

            return null;
        }
    },

    _fetchDataFromApi: function (callback) {
        const $this = this;

        if (window.location.href.replace(appUrl, '') === '/privacy') {
            return; // Otherwise, the api throws 401 Unauthorized error
        }

        $.get(appUrl + '/schools' + (schoolId ? ('/' + schoolId) : '') + '/data' + '?url='
            + window.location.href.replace(appUrl, ''),
            function (data, status) {
                if (status === 'success') {
                    if (!window.schoolDataNoCache) {
                        try {
                            const localStorage = window.localStorage;
                            localStorage.setItem($this._schoolDataKey(), JSON.stringify(data));
                            localStorage.setItem('school_data_last_saved', moment().unix().toString());
                            localStorage.setItem('auth_id', window.authId.toString());
                        } catch (e) {
                            if (!e.message.includes('exceeded the quota')) {
                                console.error("Error accessing local storage.", e);
                            }
                        }
                    }

                    if (callback) {
                        callback(data);
                    }
                } else {
                    console.error(`Error fetching school data from API. status: ${status}`);
                }
            });
    },

    _schoolDataKey: function () {
        const isInventoryUrl = window.location.href.includes('/inventory');

        return `school_data${isInventoryUrl ? '_inventory' : ''}`;
    },

    _onSchoolDataFetched: function (data) {
        this.data = data;
        this._setChangeHandlersToAppropriateFields();
        this._populateAllChangeableFields();
        if (typeof onSchoolDataLoaded === 'function') {
            onSchoolDataLoaded();
        }
        if (window.dataTable) {
            dataTable.ajax.reload();
        }
    },

    _populateAllChangeableFields: function () {
        /*
            Note, the select elements must be populated in reverse order (i.e. Groups -> Sections -> Classes etc.)
            so that a pre-populated higher-level select element can trigger change event and populate the dependent
            select element correctly. For example, if Class has pre-selected options (using "selected-val" attribute),
            then populating Class will trigger updating of Section and if Section is not yet populated, then it won't
            get the right options populated against the selected value of Class. Having Section populated before Class
            will ensure the correct values get populated in Section.
         */
        if (this.data.is_university) {
            this._populateBatches();
            this._populateStreams();
            this._populatePrograms();
            this._populateDepartments();
            this._populateFaculties();
            this._populateCampuses();
            this._populateSessions();
        } else {
            this._populateSubjects();
            this._populateExams();
            this._populateSemesters();
            this._populateElectiveSubjects();
            this._populateGroups();
            this._populateSections();
            this._populateClasses();
            this._populateShifts();
            this._populateBranches();
            this._populateSessions();
        }
    },

    _populateSessions: function () {
        this._populateItems('session', this._getSessions.bind(this));
    },

    _populateBranches: function (elementId) {
        if (elementId === undefined) {
            elementId = 'branch';
        }

        this._populateItems(elementId, this._getBranches.bind(this));
    },

    _populateShifts: function (branchId, elementId) {
        if (elementId === undefined) {
            elementId = 'shift';
        }

        this._populateItems(elementId, this._getShifts.bind(this), branchId);
    },

    _populateClasses: function (branchId, shiftId, elementId) {
        if (elementId === undefined) {
            elementId = 'class';
        }

        this._populateItems(elementId, this._getClasses.bind(this), branchId, shiftId);
    },

    _populateSections: function (branchId, shiftId, classId, elementId) {
        if (elementId === undefined) {
            elementId = 'section';
        }

        this._populateItems(elementId, this._getSections.bind(this), branchId, shiftId, classId);
    },

    _populateGroups: function (branchId, shiftId, classId, elementId) {
        if (elementId === undefined) {
            elementId = 'group_name';
        }

        this._populateItems(elementId, this._getGroups.bind(this), branchId, shiftId, classId);
    },

    _populateElectiveSubjects: function (classId, groupName) {
        this._populateItems('third_subject', this._get3rdSubjects.bind(this), classId, groupName);
        this._populateItems('fourth_subject', this._get4thSubjects.bind(this), classId, groupName);
    },

    _populateSemesters: function (classId, elementId) {
        if (elementId === undefined) {
            elementId = 'semester';
        }

        this._populateItems(elementId, this._getSemesters.bind(this), classId);
    },

    _populateExams: function (classId, semesterId, subjectId, elementId) {
        if (elementId === undefined) {
            elementId = 'exam';
        }

        this._populateItems(elementId, this._getExams.bind(this), classId, semesterId, subjectId);
    },

    _populateSubjects: function (classId, semesterId, examId, groupName, elementId) {
        if (elementId === undefined) {
            elementId = 'subject';
        }

        this._populateItems(elementId, this._getSubjects.bind(this), classId, semesterId, examId, groupName);
    },

    _populateCampuses: function (sessionId, elementId) {
        if (elementId === undefined) {
            elementId = 'campus';
        }

        this._populateItems(elementId, this._getCampuses.bind(this), sessionId);
    },

    _populateFaculties: function (sessionId, campusId, elementId) {
        if (elementId === undefined) {
            elementId = 'faculty';
        }

        this._populateItems(elementId, this._getFaculties.bind(this), sessionId, campusId);
    },

    _populateDepartments: function (sessionId, campusId, facultyId, elementId) {
        if (elementId === undefined) {
            elementId = 'department';
        }

        this._populateItems(elementId, this._getDepartments.bind(this), sessionId, campusId, facultyId);
    },

    _populatePrograms: function (sessionId, campusId, facultyId, departmentId, elementId) {
        if (elementId === undefined) {
            elementId = 'program';
        }

        this._populateItems(elementId, this._getPrograms.bind(this), sessionId, campusId, facultyId, departmentId);
    },

    _populateStreams: function (sessionId, campusId, facultyId, departmentId, programId, elementId) {
        if (elementId === undefined) {
            elementId = 'stream';
        }

        this._populateItems(elementId, this._getStreams.bind(this), sessionId, campusId, facultyId, departmentId, programId);
    },

    _populateBatches: function (campusId, facultyId, departmentId, programId, streamId, elementId) {
        if (elementId === undefined) {
            elementId = 'batch';
        }

        this._populateItems(elementId, this._getBatches.bind(this), campusId, facultyId, departmentId, programId, streamId);
    },

    _populateItems: function (selectElemId, itemOptionsFetchFunction, itemId1, itemId2, itemId3, itemId4) {
        // Instead of id selector, use attribute selector so that all elements with duplicate ids can be populated.
        // Id selector only returns first element with the id and ignores the duplicate ones.
        var selectElems = $('[id="' + selectElemId + '"]');
        if (selectElems.length) {
            selectElems.each(function (index, elem) {
                var selectElem = $(elem);
                // See if there's a default option or options with a "keep" attribute,
                // and if there are, preserve those for inserting later on.
                var keptOptions = selectElem.find('option[value=""],option[keep]');
                if (keptOptions.length) {
                    keptOptions = keptOptions.clone();
                }
                // Remove all options
                selectElem.find('option').remove();
                // Insert default/kept options if there were any
                if (keptOptions.length) {
                    selectElem.append(keptOptions);
                }
                var itemOptions = itemOptionsFetchFunction(itemId1, itemId2, itemId3, itemId4);
                // If selectElem has 'only' attribute set, keep only the items with the ids specified in 'only' attribute
                if (selectElem.attr('only') && selectElem.attr('only') !== '') {
                    const idsToKeep = selectElem.attr('only').split(',');
                    itemOptions = itemOptions.filter(option => idsToKeep.includes(option.id.toString()));
                }
                // Insert item options
                itemOptions.map(function (item) {
                    selectElem.append($('<option>', {
                        value: item.id,
                        text: item.name,
                        selected: selectElem.attr('selected-val') === item.id.toString()
                            || selectElem.attr('selected-name') === item.name.toString(),
                        disabled: selectElemId === 'section'
                            && window.location.href.replace(appUrl, '') === '/online-application/mmue'
                            && item.extras
                            && item.extras.hasOwnProperty('sectionSeatsAvailable')
                            && !item.extras.sectionSeatsAvailable
                    }));
                });
                // Hide element in case no option is available or only default option is available or only single option is available
                const onlyDefaultOptionAvailable = itemOptions.length === 1 && itemOptions[0].name === 'default';
                const onlySingleOptionAvailable = itemOptions.length === 1 || (itemOptions.length === 2 && itemOptions[0].value === '');
                const forceSelectedValue = selectElem.attr('force-selected-val');
                if (!itemOptions.length || onlyDefaultOptionAvailable || onlySingleOptionAvailable) {
                    if (!itemOptions.length || onlyDefaultOptionAvailable) {   // Select the default option and hide the input
                        selectElem.closest('.form-field-container').hide();
                        // Remove required attribute from the element so that Chrome doesn't get confused when trying to validate it
                        // See https://stackoverflow.com/questions/22148080/an-invalid-form-control-with-name-is-not-focusable
                        selectElem.removeAttr('required');
                        // Select default option if force-select-default-option attribute is specified
                        if (selectElem.attr('force-select-default-option')) {
                            selectElem.find('option').removeAttr('selected');
                            selectElem.find('option').filter((index, elem) => $(elem).text() === 'default').attr('selected', 'selected');
                        }
                    } else if (onlySingleOptionAvailable && forceSelectedValue === undefined) {    // Select the only available option
                        selectElem.find('option').removeAttr('selected');
                        selectElem.find('option').filter((index, elem) => itemOptions.length === 1 || $(elem).val() !== '').attr('selected', 'selected');
                    }
                } else {
                    selectElem.closest('.form-field-container').show();
                }
                // If an option is preselected, then trigger change event of the element so that dependent elements get
                // populated with the right options.
                if (selectElem.attr('selected-val') !== '' || selectElem.attr('selected-name') !== '') {
                    selectElem.change();
                }
                // If the element is rendered using selectpicker, refresh it
                if (selectElem.hasClass('selectpicker')) {
                    selectElem.selectpicker('refresh');
                }
            });
        }
    },

    _getSessions: function () {
        return this.data.sessions;
    },

    _getBranches: function () {
        return this._getItems('sections', 'branchId', 'branchName', function () {
            return true;
        });
    },

    _getShifts: function (branchId) {
        return this._getItems('sections', 'shiftId', 'shiftName', function (row) {
            if (branchId && row.branchId !== branchId) {
                return false;
            }
            return true;
        });
    },

    _getClasses: function (branchId, shiftId) {
        return this._getItems('sections', 'classId', 'className', function (row) {
            if (branchId && row.branchId !== branchId) {
                return false;
            }
            if (shiftId && row.shiftId !== shiftId) {
                return false;
            }
            return true;
        }).sort((a, b) => a.extras.classPosition - b.extras.classPosition);
    },

    _getSections: function (branchId, shiftId, classId) {
        return this._getItems('sections', 'sectionId', 'sectionName', function (row) {
            if (branchId && row.branchId !== branchId) {
                return false;
            }
            if (shiftId && row.shiftId !== shiftId) {
                return false;
            }
            if (classId && row.classId !== classId) {
                return false;
            }
            if (branchId && shiftId && classId) {
                return true;
            }
            if (row.sectionName === 'default') {
                return false;
            }
            return true;
        });
    },

    _getGroups: function (branchId, shiftId, classId) {
        var items = this._getItems('sections', 'classId', 'className', function (row) {
            if (branchId && row.branchId !== branchId) {
                return false;
            }
            if (shiftId && row.shiftId !== shiftId) {
                return false;
            }
            if (classId && row.classId !== classId) {
                return false;
            }
            if (!row.classHasGroups) {
                return false;
            }
            return true;
        });

        return items.length
            ? [
                {id: 'science', name: 'Science'},
                {id: 'commerce', name: 'Business Studies'},
                {id: 'arts', name: 'Humanities'}
            ]
            : [];
    },

    _get3rdSubjects: function (classId, groupName) {
        return this._getItems('electiveSubjects', 'subjectId', 'subjectName', function (row) {
            if (classId && row.classId !== classId) {
                return false;
            }
            if (groupName && row.groupName !== groupName) {
                return false;
            }
            if (row.canBe3rd !== 1) {
                return false;
            }
            return true;
        });
    },

    _get4thSubjects: function (classId, groupName) {
        return this._getItems('electiveSubjects', 'subjectId', 'subjectName', function (row) {
            if (classId && row.classId !== classId) {
                return false;
            }
            if (groupName && row.groupName && row.groupName !== groupName) {
                return false;
            }
            if (row.canBe4th !== 1) {
                return false;
            }
            return true;
        });
    },

    _getSemesters: function (classId) {
        return this._getItems('exams', 'semesterId', 'semesterName', function (row) {
            if (classId && row.classId !== classId) {
                return false;
            }
            return true;
        });
    },

    _getExams: function (classId, semesterId, subjectId) {
        return this._getItems('exams', 'examId', 'examName', function (row) {
            if (classId && row.classId !== classId) {
                return false;
            }
            if (semesterId && row.semesterId !== semesterId) {
                return false;
            }
            if (subjectId && row.subjectId !== subjectId) {
                return false;
            }
            return true;
        });
    },

    _getSubjects: function (classId, semesterId, examId, groupName) {
        return this._getItems('exams', 'subjectId', 'subjectName', function (row) {
            if (classId && row.classId !== classId) {
                return false;
            }
            if (semesterId && row.semesterId !== semesterId) {
                return false;
            }
            if (examId && row.examId !== examId) {
                return false;
            }
            if (groupName && row.group !== null && row.group !== groupName) {
                return false;
            }
            return true;
        });
    },

    _getCampuses: function (sessionId) {
        const campusIds = this._getItems('student_enrollment_setup', 'branch_id', 'branch_id', function (row) {
            if (sessionId && row.session_id !== sessionId) {
                return false;
            }
            return true;
        }).map(item => item.id);

        return this._getItems('campuses', 'id', 'name', function (row) {
            return campusIds.includes(row.id);
        });
    },

    _getFaculties: function (sessionId, campusId) {
        const facultyIds = this._getItems('student_enrollment_setup', 'faculty_id', 'faculty_id', function (row) {
            if (sessionId && row.session_id !== sessionId) {
                return false;
            }
            if (campusId && row.branch_id !== campusId) {
                return false;
            }
            return true;
        }).map(item => item.id);

        return this._getItems('faculties', 'id', 'name', function (row) {
            return facultyIds.includes(row.id);
        });
    },

    _getDepartments: function (sessionId, campusId, facultyId) {
        const departmentIds = this._getItems('student_enrollment_setup', 'department_id', 'department_id', function (row) {
            if (sessionId && row.session_id !== sessionId) {
                return false;
            }
            if (campusId && row.branch_id !== campusId) {
                return false;
            }
            if (facultyId && row.faculty_id !== facultyId) {
                return false;
            }
            return true;
        }).map(item => item.id);

        return this._getItems('departments', 'id', 'name', function (row) {
            return departmentIds.includes(row.id);
        });
    },

    _getPrograms: function (sessionId, campusId, facultyId, departmentId) {
        const programIds = this._getItems('student_enrollment_setup', 'program_id', 'program_id', function (row) {
            if (sessionId && row.session_id !== sessionId) {
                return false;
            }
            if (campusId && row.branch_id !== campusId) {
                return false;
            }
            if (facultyId && row.faculty_id !== facultyId) {
                return false;
            }
            if (departmentId && row.department_id !== departmentId) {
                return false;
            }
            return true;
        }).map(item => item.id);

        return this._getItems('programs', 'id', 'name', function (row) {
            return programIds.includes(row.id);
        });
    },

    _getStreams: function (sessionId, campusId, facultyId, departmentId, programId) {
        const streamIds = this._getItems('student_enrollment_setup', 'stream_id', 'stream_id', function (row) {
            if (sessionId && row.session_id !== sessionId) {
                return false;
            }
            if (campusId && row.branch_id !== campusId) {
                return false;
            }
            if (facultyId && row.faculty_id !== facultyId) {
                return false;
            }
            if (departmentId && row.department_id !== departmentId) {
                return false;
            }
            if (programId && row.program_id !== programId) {
                return false;
            }
            return true;
        }).map(item => item.id);

        return this._getItems('streams', 'id', 'name', function (row) {
            return streamIds.includes(row.id);
        });
    },

    _getBatches: function (campusId, facultyId, departmentId, programId, streamId) {
        // TODO: filter using campusId first
        return this._getItems('batches', 'id', 'name', function (row) {
            if (facultyId && row.faculty_id !== facultyId) {
                return false;
            }
            if (departmentId && row.department_id !== departmentId) {
                return false;
            }
            if (programId && row.program_id !== programId) {
                return false;
            }
            if (streamId && row.stream_id !== streamId) {
                return false;
            }
            return true;
        });
    },

    _getItems: function (dataset, itemIdAttribute, itemNameAttribute, filter) {
        var ids = [];
        var names = [];
        var extras = [];

        this.data[dataset].map(function (row) {
            if (!filter(row)) {
                return;
            }

            if (!ids.includes(row[itemIdAttribute])) {
                ids.push(row[itemIdAttribute]);
                names.push(row[itemNameAttribute]);
                extras.push(row);
            }
        });

        var items = [];
        for (var i = 0; i < ids.length; i++) {
            items.push({ id: ids[i], name: names[i], extras: extras[i]});
        }

        return items;
    },

    _setChangeHandlersToAppropriateFields: function () {
        var $this = this;
        if (this.data.is_university) {
            this._setChangeHandler('#session', function (event) {
                $this.onSessionChange(Number(event.target.value));
            });
            this._setChangeHandler('#campus', function (event) {
                $this.onCampusChange(Number($('#session').val()), Number(event.target.value));
            });
            this._setChangeHandler('#faculty', function (event) {
                $this.onFacultyChange(Number($('#session').val()), Number($('#campus').val()), Number(event.target.value));
            });
            this._setChangeHandler('#department', function (event) {
                $this.onDepartmentChange(Number($('#session').val()), Number($('#campus').val()), Number($('#faculty').val()), Number(event.target.value));
            });
            this._setChangeHandler('#program', function (event) {
                $this.onProgramChange(Number($('#session').val()), Number($('#campus').val()), Number($('#faculty').val()), Number($('#department').val()), Number(event.target.value));
            });
            this._setChangeHandler('#stream', function (event) {
                $this.onStreamChange(Number($('#session').val()), Number($('#campus').val()), Number($('#faculty').val()), Number($('#department').val()), Number($('#program').val()), Number(event.target.value));
            });
        } else {
            this._setChangeHandler('#branch', function (event) {
                $this.onBranchChange(Number(event.target.value));
            });
            this._setChangeHandler('#shift', function (event) {
                $this.onShiftChange(Number($('#branch').val()), Number(event.target.value));
            });
            this._setChangeHandler('#class', function (event) {
                $this.onClassChange(Number($('#branch').val()), Number($('#shift').val()), Number(event.target.value));
            });
            this._setChangeHandler('#semester', function (event) {
                $this.onSemesterChange(Number($('#class').val()), Number(event.target.value), event.target.hasAttribute('data-no-subject-change-trigger'));
            });
            this._setChangeHandler('#exam', function (event) {
                $this.onExamChange(Number($('#class').val()), Number($('#semester').val()), Number(event.target.value), event.target.hasAttribute('data-no-subject-change-trigger'));
            });
            this._setChangeHandler('#group_name', function (event) {
                $this.onGroupChange(Number($('#class').val()), event.target.value);
            });
        }
    },

    _setChangeHandler: function (fieldSelector, handler) {
        var elem = $(fieldSelector);
        if (elem.length) {
            elem.change(handler);
        }
    },

    onBranchChange: function (branch) {
        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateGroups(branch);
        this._populateSections(branch);
        this._populateClasses(branch);
        this._populateShifts(branch);
    },

    onShiftChange: function (branch, shift) {
        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateGroups(branch, shift);
        this._populateSections(branch, shift);
        this._populateClasses(branch, shift);
    },

    onClassChange: function (branch, shift, clazz) {
        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateSubjects(clazz);
        this._populateExams(clazz);
        this._populateSemesters(clazz);
        this._populateGroups(branch, shift, clazz);
        this._populateSections(branch, shift, clazz);
    },

    onGroupChange: function (clazz, groupName) {
        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateElectiveSubjects(clazz, groupName);
        this._populateSubjects(clazz, null, null, groupName);
    },

    onSemesterChange: function (clazz, semester, dontChangeSubject) {
        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        if (!dontChangeSubject) {
            this._populateSubjects(clazz, semester);
        }
        this._populateExams(clazz, semester);
    },

    onExamChange: function (clazz, semester, exam, dontChangeSubject) {
        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        if (!dontChangeSubject) {
            this._populateSubjects(clazz, semester, exam);
        }
    },

    onSessionChange: function (session) {
        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateBatches();
        this._populateStreams(session);
        this._populatePrograms(session);
        this._populateDepartments(session);
        this._populateFaculties(session);
        this._populateCampuses(session);
    },

    onCampusChange: function (session, campus) {
        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateBatches(campus);
        this._populateStreams(session, campus);
        this._populatePrograms(session, campus);
        this._populateDepartments(session, campus);
        this._populateFaculties(session, campus);
    },

    onFacultyChange: function (session, campus, faculty) {
        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateBatches(campus, faculty);
        this._populateStreams(session, campus, faculty);
        this._populatePrograms(session, campus, faculty);
        this._populateDepartments(session, campus, faculty);
    },

    onDepartmentChange: function (session, campus, faculty, department) {
        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateBatches(campus, faculty, department);
        this._populateStreams(session, campus, faculty, department);
        this._populatePrograms(session, campus, faculty, department);
    },

    onProgramChange: function (session, campus, faculty, department, program) {
        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateBatches(campus, faculty, department, program);
        this._populateStreams(session, campus, faculty, department, program);
    },

    onStreamChange: function (session, campus, faculty, department, program, stream) {
        // Note, the select elements must be populated in reverse order. See this._populateAllChangeableFields() for details.
        this._populateBatches(campus, faculty, department, program, stream);
    },

    getSubjects: function (clazz, groupName) {
        return this._getSubjects(clazz, null, null, groupName);
    }
};

window.confirmDeletion = function (route, title, onSuccess) {
    Swal.fire(
        {
            title: title || "Delete record?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f2353c",
            confirmButtonText: "Yes, delete it!",
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return fetch(
                    route,
                    {
                        method: 'delete',
                        headers: new Headers({'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}),
                        credentials: 'include'  // adds cookie header
                    }
                ).then(async function (response) {
                    if (response.status === 422) {  // Validation error
                        const responseJson = await response.json();
                        throw new Error(responseJson.message || responseJson);
                    }

                    if (!response.ok) {
                        throw new Error(response.statusText);
                    }
                }).catch(function (error) {
                    Swal.showValidationMessage('Failed to delete. ' + error);
                });
            }
        }
    ).then(function (result) {
        if (result.value) {
            Swal.fire('Deleted!', '', 'success');
            if (onSuccess) {
                onSuccess();
            }
            if (window.dataTable || typeof dataTable !== 'undefined') {
                dataTable.ajax.reload(null, false);
            }
        }
    });
};

window.editDeleteButtonsView = function (id, editRoute, deleteRoute) {
    return '<div class="actions text-nowrap">\n' +
      (editRoute !== null && editRoute !== '' ?
        '       <a href="'+ editRoute.replace('/0', '/' + id) +'" target="_blank"' +
        '          class="btn btn-icon btn-pure btn-default mr-10"' +
        '          data-toggle="tooltip"\n' +
        '          data-original-title="Edit">\n' +
        '           <i class="fa fa-edit"></i>\n' +
        '       </a>\n'
        : '') +
      (deleteRoute !== null && deleteRoute !== '' ?
        '       <a href="javascript:void(0)" ' +
        '          onclick=\'confirmDeletion( "' + deleteRoute.replace('/0', '/' + id) +'")\'' +
        '          class="btn btn-icon btn-pure btn-danger"' +
        '          data-toggle="tooltip"\n' +
        '          data-original-title="Delete">\n' +
        '           <i class="fa fa-times"></i>\n' +
        '       </a>\n'
       : '') +
        '   </div>';
};

/**
 * Disable mouse wheel on a input number field when in focus (to prevent Chromium browsers change the value when scrolling).
 * https://stackoverflow.com/questions/9712295/disable-scrolling-on-input-type-number#answer-20838527
 */
window.disableMouseWheelOnNumberInputs = function () {
    $('form input[type=number]').focus(function () {
        $(this).on('mousewheel.disableScroll', function (e) {
            e.preventDefault()
        });
    }).blur(function () {
        $(this).off('mousewheel.disableScroll')
    });
};

window.getReportFiltersHtml = function (reportFilters) {
    if (reportFilters) {
        var filtersTable = $('<table><tr></tr></table>');
        for (var i = 0; i < reportFilters.length; i++) {
            var filter = reportFilters[i];
            if (!filter.value) {
                continue;
            }
            filtersTable.append(
                '<td class="px-10">' +
                '   <span class="font-weight-600">' + filter.key + ':</span>' +
                '   <span class="pl-5">' + filter.value + '</span>' +
                '</td>'
            );
        }

        return filtersTable.html();
    }

    return '';
};

window.getReportFiltersText = function (reportFilters) {
    if (reportFilters) {
        let filterTexts = [];
        for (let i = 0; i < reportFilters.length; i++) {
            const filter = reportFilters[i];
            if (!filter.value) {
                continue;
            }
            filterTexts.push(`${filter.key}: ${filter.value}`);
        }

        return filterTexts.join('   •   ');
    }

    return '';
};

/**
 * https://stackoverflow.com/questions/4649604/jquery-select-next-text-field-on-enter-key-press#answer-10543216
 * @param inputClassName The class name of all the text fields in the group where this function should apply
 */
window.goToNextInputOnEnter = function (inputClassName) {
    $(`.${inputClassName}`).keypress(function (event) {
        if (event.keyCode === 13) {
            var textboxes = $(`input.${inputClassName}`);
            var currentBoxNumber = textboxes.index(this);
            if (textboxes[currentBoxNumber + 1] != null) {
                var nextBox = textboxes[currentBoxNumber + 1];
                nextBox.focus();
                nextBox.select();
                event.preventDefault();

                return false;
            }
        }
    });
};

/**
 * @param inputClassName The class name of all the text fields in the group where this function should apply
 */
window.goToNextRowSameColumnInputOnEnter = function (inputClassName) {
    $(`.${inputClassName}`).keypress(function (event) {
        if (event.keyCode === 13) {
            const sourceTd = $(event.target).closest('td');
            const sourceTr = $(event.target).closest('tr');
            const sourceTdIndex = sourceTr.find('td').index(sourceTd);
            const sourceTrIndex = sourceTr.parent().find('tr').index(sourceTr);

            const nextBox = sourceTr.parent().find('tr').eq(sourceTrIndex + 1)
                .find('td').eq(sourceTdIndex).find(`.${inputClassName}`);

            if (nextBox.length) {
                nextBox.focus();
                nextBox.select();
                event.preventDefault();

                return false;
            }
        }
    });
};

// Highlight corresponding menu item when page renders
window.highlightMenuItem = function (menuPath) {
    _highlightMenuItemRecursive(menuPath.split(' '));
};
function _highlightMenuItemRecursive(pathSegments) {
    if (pathSegments.length === 0) {
        return;
    }

    $('.site-menu >' + pathSegments.join(' ')).addClass('active open');

    pathSegments.splice(pathSegments.length - 1, 1);
    _highlightMenuItemRecursive(pathSegments);
}

window.nl2br = function(str) {
    return str ? str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1 <br /> $2') : '';
};

window.dataTableCellRenderCheckMarkOrEmpty = function(data, type, row, meta, addColor) {
    if (!data) {
        return '';
    }

    if (type === 'pdf' || type === 'csv') {
        return 'Yes';
    }

    return  addColor ? '<span class="text-success">✔</span>' : '✔';
}

window.dataTableCellRenderCheckMarkOrCross = function(data, type, row, meta, addColor) {
    if (type === 'pdf' || type === 'csv') {
        return data ? 'Yes' : 'No';
    }

    if (addColor) {
        return data ? '<span class="text-success">✔</span>' : '<span class="text-danger">✘</span>';
    }

    return data ? '✔' : '✘';
}

// System Setup Edit Pages - Start

window.renderTextInputColumn = function(type, inputName, value, cssClass, isRequired, errors, meta, includeIdRow, idValue){
    const error = window._getError(inputName, meta, errors);

    return `
        ${window._renderHiddenIdInput(includeIdRow, idValue, meta)}
        <div class="form-cell mb-3">
            <div class="form-group ${error ? 'has-danger' : ''}">
                <input class="form-control mx-auto ${cssClass ?? ''} ${error ? 'is-invalid' : ''}"
                       type="${type}" name="${inputName}[${meta.row}]" value="${value ?? ''}"
                       ${isRequired ? 'required' : ''} />
                <small class="invalid-feedback">${error}</small>
            </div>
        </div>
    `;
}

window.renderDateInputColumn = function(inputName, value, cssClass, isRequired, errors, meta, placeholder, dateFormat, includeIdRow, idValue){
    const error = window._getError(inputName, meta, errors);

    return `
        ${window._renderHiddenIdInput(includeIdRow, idValue, meta)}
        <div class="form-cell mb-3">
            <div class="form-group ${error ? 'has-danger' : ''}">
                <div class="input-group" style="flex-wrap: nowrap">
                    <input class="form-control mx-auto ${cssClass ?? ''} ${error ? 'is-invalid' : ''}"
                           type="text" name="${inputName}[${meta.row}]" value="${value ?? ''}"
                           id="${inputName}-${meta.row}" ${isRequired ? 'required' : ''}
                           placeholder="${placeholder ?? 'DD-MM-YYYY'}"
                           data-plugin="datepicker"
                           data-date-format="${dateFormat ?? 'dd-mm-yyyy'}"
                           data-orientation="bottom"
                           data-autoclose="true"
                           data-today-highlight="true"
                           autocomplete="off"
                    />
                    <div class="input-group-append" onclick="$('#${inputName}-${meta.row}').focus()">
                         <span class="input-group-text">
                             <i class="icon wb-calendar" aria-hidden="true"></i>
                         </span>
                    </div>
                </div>
                <small class="invalid-feedback">${error}</small>
            </div>
        </div>
    `;
}

window.renderTextAreaInputColumn = function(type, inputName, value, cssClass, isRequired, errors, meta, includeIdRow, idValue){
    const error = window._getError(inputName, meta, errors);

    return `
        ${window._renderHiddenIdInput(includeIdRow, idValue, meta)}
        <div class="form-cell mb-3">
            <div class="form-group ${error ? 'has-danger' : ''}">
                <textarea class="form-control mx-auto ${cssClass ?? ''} ${error ? 'is-invalid' : ''}"
                       type="${type}" name="${inputName}[${meta.row}]"
                       ${isRequired ? 'required' : ''}>${value ?? ''}</textarea>
                <small class="invalid-feedback">${error}</small>
            </div>
        </div>
    `;
}

window.renderSelectInputColumn = function(items, inputName, value, cssClass, isRequired, errors, meta, includeIdRow, idValue, searchable) {
    let options = '';
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        options += `
            <option value="${item.value}" ${value == item.value ? 'selected="selected"' : ''}>
                ${item.label}
            </option>
        `;
    }

    const error = window._getError(inputName, meta, errors);

    return `
        ${window._renderHiddenIdInput(includeIdRow, idValue, meta)}
        <div class="form-cell mb-3">
            <div class="form-group ${error ? 'has-danger' : ''}">
                <select class="form-control mx-auto ${cssClass ?? ''} ${error ? 'is-invalid' : ''} ${searchable ? 'selectpicker' : ''}"
                        name="${inputName}[${meta.row}]" ${isRequired ? 'required' : ''}
                        ${searchable ? 'data-live-search="true"' : ''}>
                    ${options}
                </select>
                <small class="invalid-feedback">${error}</small>
            </>
        </div>
    `;
}

window.renderCheckboxColumn = function(inputName, value, cssClass, isRequired, errors, meta, includeIdRow, idValue){
    const error = window._getError(inputName, meta, errors);

    return `
        ${window._renderHiddenIdInput(includeIdRow, idValue, meta)}
        <div class="form-cell mb-3">
            <div class="form-group ${error ? 'has-danger' : ''}">
                <div class="mt-2 abc-checkbox abc-checkbox-circle abc-checkbox-success ${cssClass ?? ''}">
                    <input name="${inputName}[${meta.row}]" id="${inputName}-${meta.row}"
                           type="checkbox" ${value ? 'checked' : ''}/>
                    <label for="${inputName}-${meta.row}" class="pl-20 pt-10"></label>
                </div>
                <small class="invalid-feedback">${error}</small>
            </div>
        </div>
    `;
}

window._renderHiddenIdInput = function(includeIdRow, idValue, meta) {
    return includeIdRow === true
        ? `<input type="hidden" name="id[${meta.row}]" value="${idValue ?? ''}"/>`
        : '';
}

window._getError = function(inputName, meta, errors) {
    const errorField = `${inputName}.${meta.row}`;

    return errors.hasOwnProperty(errorField) ? errors[errorField][0] : '';
}

// System Setup Edit Pages - End

// Common initialization point
$(function () {
    disableMouseWheelOnNumberInputs();
});
